import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import About from "./About";
import ViewCompanyDetailsHeader from "./ViewClientDetailsHeader";
import SubNavbar from "../../../layout/SubNavbar/index";

export default function ViewChallengeDetails() {
  const location = useLocation();
  const navigate = useNavigate();
  const challengeData = location?.state?.challengeData;
  const [step, setStep] = useState(1);

  const handleStepChange = (newStep) => setStep(newStep);

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
            <About clientData={challengeData} />
          </>
        );
      case 2:
        return <>{/* Add Step 2 content here */}</>;
      case 3:
        return <>{/* Add Step 3 content here */}</>;
      case 4:
        return <>{/* Add Step 4 content here */}</>;
      default:
        return null;
    }
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <SubNavbar
          title={`Challenge Details`}
          header={`Challenge`}
          subHeader={`View Challenge Details`}
        />
        <div className="card rounded-3 mt-3">
          <div className="card-body">
            <div className="d-flex justify-content-start">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => navigate(-1)}
              >
                <i className="bi bi-arrow-left"></i> Back
              </button>
            </div>
            {/* Images Section */}
            <div className="row mb-4 d-flex justify-content-center">

              <div className="col-md-6 text-center">
                <h5>Letter Image</h5>
                <img
                  src={challengeData?.latter_image}
                  alt="Letter Image"
                  className="img-fluid img-thumbnail"
                  style={{
                    width: "150px",
                    height: "150px",
                    borderRadius: "10%",
                  }}
                />
              </div>
            </div>

            <div className="d-flex justify-content-center">
              <div className="card w-75 mt-2 shadow-lg">
                <div className="card-body">
                  <div className="row">
                    {/* Left Side (Column 1) */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <h5>Challenge Title</h5>
                        <p>{challengeData?.challenge_title || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Points</h5>
                        <p>{challengeData?.points || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Start Date</h5>
                        <p>{challengeData?.start_date || "N/A"}</p>
                      </div>
                      <div className="mb-3">
                        <h5>End Date</h5>
                        <p>{challengeData?.end_date || "N/A"}</p>
                      </div>
                     
                    </div>

                    {/* Right Side (Column 2) */}
                    <div className="col-md-6">
                      <div className="mb-3">
                        <h5>Image Title</h5>
                        <p>{challengeData?.image_title || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Skip Points</h5>
                        <p>{challengeData?.skip_point || "N/A"}</p>
                      </div>

                      <div className="mb-3">
                        <h5>Description</h5>
                        <p>{challengeData?.description || "N/A"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
